import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

import { DANCE_SECTION_SLUG, NEW_TAB_SLUG } from '@/store/homeTabs/types';

/**
 * Registry of optional home "tool" tabs shown beside the default feed by
 * `HomeToolTabs` / `HomeToolPanel`. This is the single extension point:
 * adding a tab is one entry here — a slug, an i18n title key, and a
 * lazily-loaded content component. The default feed ("All") is not a tool;
 * it's the home gallery itself (`HOME_FEED_SLUG`).
 */
export interface HomeTool {
  /** Stable slug; equals `store.activeHomeTab` while this tool is open. */
  slug: string;
  /** Translation key for the tab label. */
  title: string;
  /** Panel body, code-split so its chunk loads only on first open. */
  Content: LazyExoticComponent<ComponentType>;
}

export const HOME_TOOLS: HomeTool[] = [
  {
    slug: DANCE_SECTION_SLUG,
    title: 'Motion Swap',
    Content: lazy(() => import('@/components/DanceTabContent')),
  },
  {
    slug: NEW_TAB_SLUG,
    title: 'New',
    Content: lazy(() => import('@/components/NewTabContent')),
  },
];
